import { getConfig } from "../config";
function getSymbol(countryCode) {
  const { COUNTRY } = getConfig();
  const symbols = {
    gb: "\xA3",
    nl: "\u20AC",
    it: "\u20AC",
    fr: "\u20AC",
    es: "\u20AC",
    de: "\u20AC"
  };
  return symbols[countryCode || COUNTRY] || "\xA3";
}
function getThousandSeparator(countryCode) {
  const { COUNTRY } = getConfig();
  const symbols = {
    gb: ",",
    nl: ".",
    it: ".",
    fr: " ",
    es: ".",
    de: "."
  };
  return symbols[countryCode || COUNTRY] || ",";
}
function getDecimalSeparator(countryCode) {
  const { COUNTRY } = getConfig();
  const symbols = {
    gb: ".",
    nl: ",",
    it: ",",
    fr: ",",
    es: ",",
    de: ","
  };
  return symbols[countryCode || COUNTRY] || ".";
}
const format = (input, symbolParam, places = 2, thousandParam, decimalParam) => {
  if (input !== 0 && !input) {
    return "";
  }
  const symbol = symbolParam || getSymbol();
  const thousand = thousandParam || getThousandSeparator();
  const decimal = decimalParam || getDecimalSeparator();
  places = !Number.isNaN(Number(places = Math.abs(places))) ? places : 2;
  let number = input / 100;
  const negative = number < 0 ? "-" : "";
  const i = `${parseInt(number = Math.abs(+number || 0).toFixed(places), 10)}`;
  let j;
  j = (j = i.length) > 3 ? j % 3 : 0;
  return symbol + negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${thousand}`) + (places ? decimal + // @ts-ignore
  Math.abs(number - i).toFixed(places).slice(2) : "");
};
const accountingFormat = (value) => (
  // eslint-disable-next-line no-nested-ternary
  (value > 0 ? "+" : value < 0 ? "-" : "") + format(Math.abs(value))
);
const parse = (price) => {
  if (price === void 0 || price === "") {
    return "";
  }
  const float = parseFloat(price.replace(/[^0-9-.]/g, ""));
  const int = parseInt((float * 100).toFixed(0), 10);
  return int;
};
export {
  accountingFormat,
  format,
  getDecimalSeparator,
  getSymbol,
  getThousandSeparator,
  parse
};
